import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=898a6d62&scoped=true"
import script from "./protocol.vue?vue&type=script&lang=ts"
export * from "./protocol.vue?vue&type=script&lang=ts"
import style0 from "./protocol.vue?vue&type=style&index=0&id=898a6d62&prod&scoped=true&lang=less"
import style1 from "./protocol.vue?vue&type=style&index=1&id=898a6d62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898a6d62",
  null
  
)

export default component.exports